import {Skeleton} from '@gwc/core'
import {Box} from '@yandex-delivery/blocks'
import React from 'react'

import * as classes from './InputSkeleton.classes'

export const InputSkeleton = (): React.ReactElement => (
  <Box alignItems={'center'} className={classes.wrapper.content} justifyContent={'space-between'}>
    <Box className={classes.wrapper.label} flexDirection={'column'}>
      <Skeleton className={classes.skeleton.label} />
      <Skeleton className={classes.skeleton.label} />
    </Box>
    <Skeleton className={classes.skeleton.input} />
  </Box>
)
